module.exports = __webpack_public_path__ + "images/emoji/dizzy.92ceadf67c74b5c45f79.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dizzy.png
// module id = A7t0
// module chunks = 1